import { render, staticRenderFns } from "./assign-driver.vue?vue&type=template&id=621f3809&scoped=true&"
import script from "./assign-driver.vue?vue&type=script&lang=js&"
export * from "./assign-driver.vue?vue&type=script&lang=js&"
import style0 from "./assign-driver.vue?vue&type=style&index=0&id=621f3809&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621f3809",
  null
  
)

export default component.exports